import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';

const CTA = () => {
  return (
    <>
      <section className="py-20 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="relative rounded-3xl bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-700 p-10 lg:p-16 overflow-hidden">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-y-24 translate-x-24" aria-hidden />
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-emerald-400/20 rounded-full blur-3xl translate-y-20 -translate-x-20" aria-hidden />
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, white 1px, transparent 1px)', backgroundSize: '30px 30px' }} aria-hidden />

            <div className="relative grid lg:grid-cols-2 gap-10 items-center">
              <div className="text-white">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur text-xs font-semibold mb-5">
                  <Sparkles className="w-3.5 h-3.5" /> Commencez aujourd'hui
                </div>
                <h2 className="text-4xl lg:text-5xl font-bold leading-tight mb-5">Prêt à commencer votre formation ?</h2>
                <p className="text-teal-50 text-lg leading-relaxed max-w-lg">Explorez notre catalogue et trouvez la formation qui correspond à vos besoins professionnels. Prise en charge totale, accompagnement sur mesure.</p>
              </div>
              <div className="flex flex-wrap gap-3 lg:justify-end">
                <Link to="/formations">
                  <Button size="lg" className="bg-white text-teal-700 hover:bg-slate-100 h-12 px-6 shadow-lg">
                    Voir toutes les formations <ArrowRight className="w-4 h-4 ml-1" />
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button size="lg" variant="outline" className="border-white/40 bg-white/10 text-white hover:bg-white/20 hover:text-white h-12 px-6 backdrop-blur">
                    Nous contacter
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CTA;
